import React from 'react'
import {
  LayoutDashboard,
  Store,
  ShoppingBag,
  ClipboardList,
  ShieldCheck,
  Wallet,
  Smartphone,
} from 'lucide-react'
import { BasicLayout as CommonBasicLayout } from '@njnorge/admin-common'
import { authApi } from '../api/auth'
import { routeConfig, getMenuItem } from '../config/routes'

const iconMap: Record<string, React.ReactNode> = {
  LayoutDashboard: <LayoutDashboard size={18} />,
  Store: <Store size={18} />,
  ShoppingBag: <ShoppingBag size={18} />,
  ClipboardList: <ClipboardList size={18} />,
  ShieldCheck: <ShieldCheck size={18} />,
  Wallet: <Wallet size={18} />,
  Smartphone: <Smartphone size={18} />,
}

export const BasicLayout = () => {
  return (
    <CommonBasicLayout
      brandTitle="CREST"
      brandSubtitle="DINING"
      brandLetter="C"
      routeConfig={routeConfig}
      getMenuItem={getMenuItem}
      iconMap={iconMap}
      onLogout={async () => {
        await authApi.logout()
      }}
    />
  )
}

export default BasicLayout
